export const unilevel_routes = [
  {
    path: "/unilevel",
    component: () => import("../Main.vue"),
    name: "Minha Rede"
  }
];

export default {};
